import { Navigate, Link as RouterLink } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { routes } from '@/router'
import { Box, Link, Stack, TextField, Typography } from '@mui/material'
import { ArrowBack } from '@mui/icons-material'
import {
  PasswordRecoveryFormData,
  passwordRecoveryFormSchema,
} from './form.shema'
import { LoadingButton } from '@mui/lab'
import { useRecoverPassword } from '@/api/user-manager'
import { useState } from 'react'
import { EmailSent } from './email-sent.component'

export function PasswordRecoveryPage() {
  const [isEmailSent, setIsEmailSent] = useState(false)

  const accessToken = localStorage.getItem('access_token')

  const { handleSubmit, control, getValues } =
    useForm<PasswordRecoveryFormData>({
      resolver: zodResolver(passwordRecoveryFormSchema),
      defaultValues: {
        email: '',
      },
    })

  const { mutateAsync: recoverPassword, isPending } = useRecoverPassword({
    onSuccess: () => setIsEmailSent(true),
  })

  function handleSubmitRecovery({ email }: PasswordRecoveryFormData) {
    recoverPassword({ email })
  }

  // ensure user is in home page if has access token
  if (accessToken) {
    return <Navigate to={routes.home} />
  }

  return (
    <>
      {isEmailSent ? (
        <EmailSent email={getValues('email')} />
      ) : (
        <Box
          component="form"
          onSubmit={handleSubmit(handleSubmitRecovery)}
          height="50vh"
          maxWidth={360}
          margin="auto"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="stretch"
          gap={4}
        >
          <Typography variant="h3" align="center">
            Recuperação de senha
          </Typography>

          <Stack spacing={3}>
            <Controller
              name="email"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  label="Insira seu e-mail"
                  error={Boolean(error)}
                  slotProps={{
                    input: {
                      autoCapitalize: 'none',
                      style: { textTransform: 'lowercase' },
                    },
                  }}
                  helperText={error?.message}
                  {...field}
                  onChange={(e) => field.onChange(e.target.value.toLowerCase())}
                />
              )}
            />

            <LoadingButton
              type="submit"
              size="large"
              fullWidth
              loading={isPending}
            >
              Enviar
            </LoadingButton>
          </Stack>

          <Link
            component={RouterLink}
            to={routes.session.signin}
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap={1}
          >
            <ArrowBack sx={{ fontSize: 18 }} />
            Voltar para o login
          </Link>
        </Box>
      )}
    </>
  )
}
